const noop = () => undefined;
noop.noop = true;
export default noop;
